<template>
  <v-card
    flat
    id="scroll-target"
    class="transparent text--white align-center justify-center d-flex overflow-y-auto fill-height"
    style="max-height: 100% !important;"
  >
    <v-card flat class="text--white transparent mt-12 pt-7" :width="width" id="scrolled-content">
      <div
        :class="{'title':  $vuetify.breakpoint.smAndDown, 'display-2':  $vuetify.breakpoint.mdAndUp}"
      >
        <b>Frequently Asked Questions</b>
      </div>
      <v-expansion-panels
        focusable
        popout
        :class="{'mt-2':  $vuetify.breakpoint.smAndDown, 'mt-8':  $vuetify.breakpoint.mdAndUp}"
      >
        <v-expansion-panel v-for="item in faq" :key="item.id">
          <v-expansion-panel-header class="faq-header" @click="scrollBottom()">
            <b :class="headerClass">{{item.quest}}</b>
          </v-expansion-panel-header>
          <v-expansion-panel-content :class="contentClass">{{item.answer}}</v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-card>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    scrollBottom() {
      setTimeout(function() {
        let elem = document.getElementById("scrolled-content");
        let container = document.getElementById("scroll-target");
        container.scrollTop = Math.floor(elem.offsetHeight);
      }, 200);
    }
  },
  computed: {
    faq() {
      return [
        {
          id: 1,
          quest: this.$t("faq.text1"),
          answer: this.$t("faq.answer1")
        },
        {
          id: 2,
          quest: this.$t("faq.text2"),
          answer: this.$t("faq.answer2")
        },
        {
          id: 3,
          quest: this.$t("faq.text3"),
          answer: this.$t("faq.answer3")
        },
        {
          id: 4,
          quest: this.$t("faq.text4"),
          answer: this.$t("faq.answer4")
        }
      ]
    },
    contentClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "caption text-left";
        case "sm":
          return "caption text-left";
        case "md":
          return "title text-left";
        case "lg":
          return "headline text-left";
        case "xl":
          return "display-1 text-left";
      }
    },
    headerClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "body-2 text-left";
        case "sm":
          return "body-2 text-left";
        case "md":
          return "headline text-left";
        case "lg":
          return "display-1 text-left";
        case "xl":
          return "display-2 text-left";
      }
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "90%";
        case "sm":
          return "95%";
        default:
          return "70%";
      }
    }
  }
};
</script>
